export function usePrint() {
    const printPage = (elementId = "printable") => {

        const printable = document.getElementById(elementId);
        if (!printable) return;

        const printContents = printable.innerHTML;
        const originalContents = document.body.innerHTML;

        // Temporarily replace the body with printable content
        document.body.innerHTML = printContents;
        window.print();

        // Restore the original content after printing
        document.body.innerHTML = originalContents;

        // Reload to reinitialize Vue state and restore bindings
        window.location.reload();
    };

    return { printPage };
}